import ListOrders from './ListOrders';
export default ListOrders;



// WEBPACK FOOTER //
// ./src/pages/SubmissionCrmErrorsPage/components/ListOrders/components/ListOrders/index.ts